<template>
  <div>
    <spinner v-if="loading"></spinner>

    <div v-else class="w-full">
      <div>
        <h1 class="text-2xl font-bold text-center text-primary">
          ผลการประเมินด้านความเสี่ยงต่อสุขภาพ
        </h1>
        <h1 class="text-xl font-light text-center">Health Risk Assessment</h1>
      </div>

      <div class="mt-12">
        <h1 class="text-xl text-center">แบ่งตามคณะ</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร {{ group.faculty.total_count }} คน
        </p>
        <risk-stacked-chart
          v-if="group.faculty.faculties"
          class="w-2/3 mx-auto h-96"
          :labels="group.faculty.faculties"
          :low="group.faculty.risk_level_count.low.data"
          :mid="group.faculty.risk_level_count.mid.data"
          :high="group.faculty.risk_level_count.high.data"
        />
      </div>

      <div class="mt-12">
        <h1 class="text-xl text-center">แบ่งตามประเภทพนักงาน</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร {{ group.employee_type.total_count }} คน
        </p>

        <risk-stacked-chart
          class="w-2/3 mx-auto h-96"
          :labels="group.employee_type.employee_types"
          :low="group.employee_type.risk_level_count.low.data"
          :mid="group.employee_type.risk_level_count.mid.data"
          :high="group.employee_type.risk_level_count.high.data"
        />
      </div>

      <div class="mt-12">
        <h1 class="text-xl text-center">แบ่งตามเพศ</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร {{ group.gender.total_count }} คน
        </p>

        <risk-stacked-chart
          class="w-2/3 mx-auto h-96"
          :labels="group.gender.genders"
          :low="group.gender.risk_level_count.low.data"
          :mid="group.gender.risk_level_count.mid.data"
          :high="group.gender.risk_level_count.high.data"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./charts/BarChart";
import RiskStackedBarChart from "./charts/RiskStackedBarChart";
import { Tabs, Tab } from "vue-slim-tabs";
import axios from "axios";
import Spinner from "@/components/loading/Spinner";
import EventBus from "@/events/event-bus.js";

export default {
  name: "hplp-dashboard",
  components: {
    BarChart,
    "risk-stacked-chart": RiskStackedBarChart,
    Tabs,
    Tab,
    Spinner,
  },
  created() {
    this.fetchGroup();

    EventBus.$on("dashboardYearChanged", this.fetchGroup);
    EventBus.$on("dashboardEmployeeTypeChanged", this.fetchGroup);
  },
  beforeDestroy() {
    EventBus.$off("dashboardYearChanged", this.fetchGroup);
    EventBus.$off("dashboardEmployeeTypeChanged", this.fetchGroup);
  },
  data() {
    return {
      group: {},
      loading: true,
    };
  },
  methods: {
    async fetchGroup() {
      this.loading = true;

      try {
        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_API_URL}/dashboard/risk/group?year=${this.$store.state.dashboardYear}&employeeType=${this.$store.state.dashboardEmployeeType}`,
          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.group = response.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style src="vue-slim-tabs/themes/default.css"></style>
